import { createContext } from 'use-context-selector';

export interface BoardMembersContextValue {
  /**
   * List of memberIds of deactivated users.
   * users are considered deactivated if the membership type is "deactivated"
   * or if they have activityBlocked set to true on their member object.
   */
  deactivatedIds: Set<string>;
}

export const emptyBoardMembersContext: BoardMembersContextValue = {
  deactivatedIds: new Set(),
};

export const BoardMembersContext = createContext<BoardMembersContextValue>(
  emptyBoardMembersContext,
);
